enum CalcomStatus {
  accepted = "ACCEPTED",
  pending = "PENDING",
  cancelled = "CANCELLED",
  rejected = "REJECTED"
}

export default CalcomStatus
